import styled from 'styled-components';

export const TagName = styled.div`
  font-weight: bold;
  font-size: 11px;
  display: inline-block;
`;

export const Post = styled.div`
  padding: 5px;
  border-radius: 5px;
  border: solid;
  border-width: 1px;
`;

export const PostTextarea = styled.textarea`
  width: 100%;
`;

export const PostName = styled.div`
  float: left;
`;

export const PostTitle = styled.div`
  font-weight: bold;
  float: left;
  margin-right: 5px;
`;

export const PostTime = styled.div`
  float: right;
`;

export const PostUpdating = styled.div`
  float: left;
  color: red;
  font-weight: bold;
`;

export const Button = styled.button`
  padding: 5px;
  border-radius: 5px;
  border: solid;
  width: 200px;
  text-align: center;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: blue;
  }
`;
